"use client";
import React, { useState, useEffect } from "react";
// import "../../styles/globals.css";
// import "../EcommerceBot/styles/globals.css";
import "../styles/globals.css";
import axios from "axios";
import { Container, Row, Col, Card, Form, Button, Alert, Spinner, ToggleButton, Modal,ToggleButtonGroup} from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function Endpoints() {
  const [showPrevScreen, setShowPrevScreen] = useState(true);
  const [webhookEndpoint, setWebhookEndpoint] = useState(false);
  const [downloadingFile, setDownloadingFile] = useState(false);
  const [endpointStatus, setEndpointStatus] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [formData, setFormData] = useState({
    endpoint_name: "",
    icon_name: "",
    webhoook_endpoint: false,
    url: "",
    path: "",
    headers: [{ key: "", value: "" }],
    method: "",
  });
  console.log("FormData:", formData);
  const [options, setOptions] = useState([]); // State to store API response
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [question, setQuestion] = useState("");
  const navigate = useNavigate();
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
  const handleHeaderChange = (index, event) => {
    const { name, value } = event.target;
    const newHeaders = [...formData.headers];

    // Update the value of the changed input field
    newHeaders[index][name] = value;
    setFormData({ ...formData, headers: newHeaders });

    // Condition to add a new row if the last input has a value
    if (
      name === "key" &&
      value.length === 1 &&
      index === newHeaders.length - 1
    ) {
      // Add a new empty row only if it's the last row
      setFormData({
        ...formData,
        headers: [...newHeaders, { key: "", value: "" }],
      });
    }

    // Condition to remove the last row if it is empty
    if (
      name === "key" &&
      value.length === 0 &&
      index === newHeaders.length - 2
    ) {
      // Check if the last row is empty
      setFormData({
        ...formData,
        headers: newHeaders.slice(0, -1),
      });
    }
  };

  const handleShowPrevScreen = () => {
    setShowPrevScreen(!showPrevScreen);
  };

  // Function to call API when "Show options" button is clicked
  const handleShowOptions = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `https://cqube.sstus.net/get_answer`,
        {
          question,
          type: "endpoint",
          integration_name: provider_name,
          base_url: base_url,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}` // Add your bearer token here
          },
        }
      );
      console.log("response in endpoint", response);
      if (response.status === 200) {
        console.log("response in endpoint", response.data);
        setOptions(
          response.data.Endpoint_details || response.data.endpoints || []
        );
      } else {
        throw new Error("Failed to fetch endpoints");
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response && error.response.status === 403) {
        localStorage.removeItem("token");
        localStorage.removeItem("isLoggedIn");
        setError("Session expired. Please login again.");
        navigate("/login", { state: { from: "/EcommerceBot" } });
      } else {
        setError(error.message);
      }
    } finally {
      setLoading(false);
    }
  };
  const [provider_name, setProvider_name] = useState(null);
  const [base_url, setBaseUrl] = useState(null);
  

return (
  <Container className="d-flex min-vh-100 justify-content-center align-items-center" style={{ backgroundColor: "#1A1A1A" }}>
    <Card className="p-4 w-100" style={{ maxWidth: "700px", backgroundColor: "#1c1c1e", color: "white" }}>
      {showPrevScreen ? (
        <>
          <h1 className="text-center">Create Endpoint</h1>
          <Form>
            <Row className="mb-3">
              <Col>
                <Form.Control
                  type="text"
                  placeholder="Enter the provider name"
                  value={provider_name}
                  onChange={(e) => setProvider_name(e.target.value)}
                />
              </Col>
              <Col>
                <Form.Control
                  type="text"
                  placeholder="Enter the baseURL"
                  value={base_url}
                  onChange={(e) => setBaseUrl(e.target.value)}
                />
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>What endpoint you're integrating with?</Form.Label>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    placeholder="Example: Get order detail"
                    value={question}
                    onChange={(e) => setQuestion(e.target.value)}
                  />
                </Col>
                <Col xs="auto">
                  <Button variant="info" onClick={handleShowOptions}>
                    Show options
                  </Button>
                </Col>
              </Row>
            </Form.Group>
            {loading && <Spinner animation="border" variant="light" />}
            {error && <Alert variant="danger">Error: {error}</Alert>}
            <Row className="g-3">
              {options.length > 0 ? (
                options.map((option, index) => (
                  <Col key={index} md={6}>                    
                    <Card className="p-3" bg="dark" text="light" onClick={() => setSelectedOption(option)}>
                      <Card.Title>{option.name}</Card.Title>
                      <Card.Text>
                        <strong>Base URL:</strong>{" "}
                        <a href={option.url} className="text-info" target="_blank" rel="noopener noreferrer">
                          {option.url}
                        </a>                        
                      </Card.Text>
                    </Card>
                  </Col>
                ))
              ) : (
                !loading && <p className="text-muted">No options available</p>
              )}
            </Row>
          </Form>
        </>
      ) : (
        <>
          <h1 className="text-center text-info">Create Endpoint</h1>
          <Row className="mb-3">
            <Col>
              <Form.Control type="text" placeholder="Endpoint name" />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label>Webhook endpoint?</Form.Label>
              <ToggleButtonGroup type="checkbox" name="webhook">
                <ToggleButton variant="primary" value={1}>
                  Yes
                </ToggleButton>
              </ToggleButtonGroup>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <Button variant="outline-info" onClick={() => setShowPrevScreen(true)}>
                Back
              </Button>
            </Col>
            <Col className="text-end">
              <Button variant="primary">Save Endpoint</Button>
            </Col>
          </Row>
        </>
      )}
    </Card>

    {/* Modal for detailed endpoint information */}
    <Modal show={!!selectedOption} onHide={() => setSelectedOption(null)} centered>
      <Modal.Header closeButton>
        <Modal.Title>View {selectedOption?.name} endpoint details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedOption && (
          <>
          <p>
            <strong>Provider Name:</strong>
            {provider_name}
          </p>
            <p>
              <strong>Base URL:</strong>{" "}
              <a href={selectedOption.url} className="text-info" target="_blank" rel="noopener noreferrer">
                {selectedOption.url}
              </a>
            </p>
            <p>
              <strong>Path:</strong> {selectedOption.https?.path}             
            </p>
            <p>
              <strong>Method:</strong> {selectedOption.https?.method}
            
            </p>
            <p>
              <strong>Headers:</strong>
            </p>
            <p><strong>Content Type:</strong> {selectedOption.https?.contentType}</p>            
            <p><strong>Authorization:</strong> {selectedOption.https?.headers?.Authorization || "No Authorization required"}</p>
            
            {/* <pre>{JSON.stringify(selectedOption.https?.headers, null, 2)}</pre> */}
            <p><strong>Request Schema:</strong></p>
            <pre>{JSON.stringify(selectedOption.https?.requestSchema, null, 2)}</pre>

            <p><strong>Response Schema:</strong></p>
            <pre>{JSON.stringify(selectedOption.https?.responseSchema, null, 2)}</pre>

            {/* <pre>{JSON.stringify(selectedOption.headers, null, 2)}</pre> */}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
       
        <Button variant="secondary" onClick={() => setSelectedOption(null)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  </Container>
);

}
